import React from "react";
import PropTypes from "prop-types";
import UnstyledImage from "./image";
import styled from "styled-components";

const Wrapper = styled.div`
  position: relative;
  min-height: clamp(40vh, 40vw, 800px);
  height: 100%;
  width: 100%;
  max-width: 1920px;
`;
const InnerWrapper = styled.div`
  position: relative;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
`;
const Image = styled(UnstyledImage)`
  position: absolute;
  inset: 0;
  z-index: -1;
`;
const Children = styled.div`
  position: relative;
  display: grid;
  place-content: center;
  height: 100%;
  width: 100%;
  padding-inline: 100px;
  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
  }
  @media (max-width: ${({ theme }) => theme.breakpoints.phone}) {
    padding-inline: 20px;
    line-height: 1.1;
    font-size: 0.8rem;
  }
  *:not(a) {
    color: white;
  }
  * {
    text-align: left;
    font-size: 30px;
    font-family: ${({ theme }) =>
      theme.typography.light
        ? theme.typography.light
        : theme.fontParagraphs.fontFamily};
    @media (max-width: ${({ theme }) => theme.breakpoints.phone}) {
      display: none;
    }
  }
  h1,
  h2 {
    font-size: clamp(1.5rem, 8vw, 3rem);
    font-family: var(--font-headings);
    text-shadow: 1px 1px 5px rgba(0, 0, 0, 0.5);
    @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
      display: block;
    }
  }
  div {
    font-size: 20px;
    @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
      font-size: 25px;
    }
  }
  .button-container {
    margin-top: 2rem;
    padding: 0;
    justify-content: flex-start;
    a {
      font-size: 1rem;
      font-family: var(--font-links);
      min-width: 300px;
    }
    span {
      font-size: 20px;
      @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
        font-size: 25px;
      }
    }
  }
`;

const SuperheroSlide = ({ children, image, ...props }) => {
  return (
    <Wrapper {...props}>
      <Image image={image} loading="eager" />
      <InnerWrapper>
        <Children>{children}</Children>
      </InnerWrapper>
    </Wrapper>
  );
};

SuperheroSlide.propTypes = {
  image: PropTypes.shape({
    altText: PropTypes.string,
    focalPoint: PropTypes.shape({
      objectPosition: PropTypes.string,
    }),
    localFile: PropTypes.shape({
      childImageSharp: PropTypes.shape({
        gatsbyImageData: PropTypes.object,
      }),
    }),
  }),
  children: PropTypes.node,
};

export default SuperheroSlide;
